export const HOMEPAGE = 'HOMEPAGE'
